import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Pane, Heading, Button, Spinner } from 'evergreen-ui';

import { getShop, updateShop } from '../actions/ShopActions';
import ShopForm from '../components/ShopForm';
import InfoBlock from '../../common/InfoBlock/InfoBlock';
import Configuration from '../Config';

const validation = Configuration.Validations.shop;
const mapValidationErrors = Configuration.ErrorHandler.mapValidationErrors;

class EditShop extends Component {
    constructor(props) {
        super(props);
        this.id = this.props.params.id;
    }

    componentDidMount() {
        this.props.dispatch(getShop(this.id));
    }

    handleSave = (values) => {
        this.props.dispatch(updateShop(this.id, values));
    }

    render() {
        const { current, loading } = this.props;

        if (loading || !current.id) {
            return (
                <Pane display="flex" alignItems="center" justifyContent="center" height={400}>
                    <Spinner />
                </Pane>
            );
        }

        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/shops">
                            <Button iconBefore="arrow-left" intent="none">
                                Înapoi la lista magazinelor
                            </Button>
                        </Link>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Editare Magazin: {current.name}
                    </Heading>
                </Pane>

                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <InfoBlock flex="1">
                        <ShopForm
                            isEdit={true}
                            initialValues={current.export ? current.export() : current}
                            validationSchema={validation}
                            onSave={this.handleSave}
                            errors={this.props.errors}
                        />
                    </InfoBlock>
                </Pane>
            </Pane>
        );
    }
}

function mapStateToProps(state) {
    return {
        current: state.shops.current,
        loading: state.loading.active,
        errors: state.shops.errors.type === 'validation'
            ? mapValidationErrors(state.shops.errors.fields)
            : []
    };
}

export default connect(mapStateToProps)(EditShop);
